import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  where,
  updateDoc,
  arrayUnion,
  getDocs,
  deleteDoc,
  limit,
  orderBy,
  prefix,
} from "firebase/firestore";
import { db } from "../../config/FirebaseConfig.js"; // Import the Firebase setup
import addLogDocument from "../addLogDocument"; // Assuming you have this function
import { fileOpen } from "browser-fs-access"; // Used for file picker
import { checkDB, getRefFromId } from "../../models/DataFunctions.js";
import updateDocApi from "../database/updateDocApi.js";

const sendFileF = async (
  token,
  folderconvRef,
  content,
  receiver,
  folderid,
  senderRef,
  prefix
) => {
  const auth = getAuthCentral();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    console.error("User not logged in");
    return;
  }

  const userRef = doc(db, "user", currentUser.uid);
  const userSnapshot = await getDoc(checkDB(userRef));
  const org_id = userSnapshot.get("org_id");

  try {
    // File picker to allow user to choose a file
    const file = await fileOpen({
      mimeTypes: ["application/pdf", "application/xml", "application/zip"], // Specify file types
    });

    if (file) {
      // Create a new message document
      const newMessageRef = doc(collection(db, "message"));
      await setDoc(newMessageRef, {
        content: content,
        author_id: senderRef.id || "particulier",
        post_date: new Date(),
        receiver: receiver,
      });
      let folderconv = await getDoc(folderconvRef);
      let folderconvData = folderconv.data();
      let messages = folderconvData.messages || [];
      messages.push(newMessageRef);

      // Update the folder conversation
      await updateDocApi(
        folderconvRef,
        {
          messages: messages,
        },
        prefix
      );
      // Prepare file for upload
      const formData = new FormData();
      const fileName = file.name.replaceAll(" ", "_");
      formData.append("file", file, fileName);

      // Define the endpoint URL
      const url =
        prefix + `folders/${folderid}/message/${newMessageRef.id}/file`;

      // Set request headers
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      // Send the request using fetch instead of axios
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formData, // Send the form data
      });

      // Log the response
      await addLogDocument(
        url,
        prefix,
        userRef,
        org_id,
        response.status.toString(),
        "", // folderid
        "", // docid
        "", // No request body to log here
        await response.text(),
        "POST"
      );

      if (response.ok) {
        return "uploaded";
      } else {
        console.error(`Error uploading file: ${response.status}`);
        return "not uploaded";
      }
    } else {
      return "no file";
    }
  } catch (error) {
    console.error(`Error during file upload: ${error.message}`);
    return "no file";
  }
};

export default sendFileF;
